'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var QA_SUFFIX = window.location.href.indexOf('hubspotqa.com') !== -1 ? 'qa' : '';
var IS_LOCAL = window.location.href.indexOf('://local.hubspot') !== -1;
var IS_API_LOCAL = window.localStorage && window.localStorage.HOME_API_ENV === 'local';

var APP_ROOT_PATH = 'https://app.hubspot' + QA_SUFFIX + '.com';
var LOCAL_APP_ROOT_PATH = 'https://local.hubspot' + QA_SUFFIX + '.com';
var API_ROOT_PATH = 'https://api.hubspot' + QA_SUFFIX + '.com';
var LOCAL_API_ROOT_PATH = 'https://local.hubspot' + QA_SUFFIX + '.com';

var api = exports.api = function api(path) {
  var root = IS_API_LOCAL ? LOCAL_API_ROOT_PATH : API_ROOT_PATH;
  return '' + root + path;
};

var contactSupport = exports.contactSupport = function contactSupport() {
  return 'mailto:support@hubspot.com';
};

var error = exports.error = function error() {
  var root = IS_LOCAL ? LOCAL_APP_ROOT_PATH : APP_ROOT_PATH;
  return root + '/home-beta/error' + window.location.search;
};

var profileAndPreferences = exports.profileAndPreferences = function profileAndPreferences(portalId) {
  return APP_ROOT_PATH + '/user-preferences/' + portalId;
};

var login = exports.login = function login(location, portalId) {
  var portalIdEscaped = portalId || '';
  return APP_ROOT_PATH + '/login?loginPortalId=' + portalIdEscaped + '&loginRedirectUrl=' + encodeURIComponent(location);
};


//////////////////
// WEBPACK FOOTER
// ./js/utils/urls.js
// module id = 3
// module chunks = 0 1